import { supabase } from "./supabaseClient";

// Supabase sends at most 1,000 rows per request.
const PAGE_SIZE = 1000;

// Every UK postcode district with its centre (about 2,900 rows), for the
// radius picks: [{ outcode, lat, lng, live_postcodes, area }].
export async function fetchPostcodeDistricts() {
  const all = [];
  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from("postcode_districts")
      .select("outcode, lat, lng, live_postcodes, area")
      .order("outcode")
      .range(from, from + PAGE_SIZE - 1);
    if (error) { console.error("fetchPostcodeDistricts", error); break; }
    if (!data || data.length === 0) break;
    all.push(...data);
    if (data.length < PAGE_SIZE) break;
  }
  return all;
}
